import { GenericObject } from 'app/core/utils';

export class PdfParams {
  product: string = '';
  brand: string = '';
  version: string = '';
  lang: string = '';

  constructor(params: GenericObject) {
    this.product = params?.['product'];
    this.brand = params?.['brand'];
    this.version = params?.['version'];
    this.lang = params?.['lang'];
  }
}
